import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";

const { DateTime } = require("luxon");

class FlexoffersCommissionData extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            commissions: [],
            commissionsLoading: false,
            affiliateCommissionId: this.props.affiliateCommissionId,
            affiliateCommissionIdError: false,
            CommissionsTable: {
                title: "Affiliate commissions",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'commissionName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    typography: {
                        fontFamily: "'Urbanist', 'sf_pro_displayregular', sans-serif",
                    },
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                        MUIDataTableBody: {
                            emptyTitle: {
                                textAlign: 'left',
                                paddingLeft: '385px',
                                paddingTop: '12px',
                                verticalAlign: 'top',
                                fontFamily: "'Urbanist', sans-serif",
                                fontSize: '16px',
                            }
                        }
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });

        if (!!(this.props.affiliateCommissionId)) {
            this.getCommissions();
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (!!(this.props.affiliateCommissionId) && prevProps.affiliateCommissionId !== this.props.affiliateCommissionId) {
            this.getCommissions();
        }
    }

    getCommissions = async () => {
        if (!(this.props.affiliateCommissionId)) {
            this.setState({ affiliateCommissionIdError: true });
        }
        console.log("in")

        let url = `/api/Merchant/GetFlexoffersCommissionRawDataById?id=` + this.props.affiliateCommissionId;

        this.setState({ commissionsLoading: true, affiliateCommissionIdError: false });

        try {
            const commissions = await getRequest(url);

            this.setState({
                commissions,
                commissionsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching commissions:", error);
            this.setState({ commissions: [], commissionsLoading: false });
        }
    };

    onTabChange = (tab) => {
        this.setState({ tab });
    }

    render() {
        const columns = [
            {
                name: "commissionHistoryId",
                label: "Commission History ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "commissionId",
                label: "Commission ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "flexoffersSalesId",
                label: "FlexOffers Sales ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "transactionKey",
                label: "Transaction Key",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "programId",
                label: "Program ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "programName",
                label: "Program Name",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "productId",
                label: "Product ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "productName",
                label: "Product Name",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "categoryId",
                label: "Category ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "categoryName",
                label: "Category Name",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "domainId",
                label: "Domain ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "domainName",
                label: "Domain Name",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "accountId",
                label: "Account ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "accountName",
                label: "Account Name",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "tracking",
                label: "Tracking",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "subTracking",
                label: "Sub Tracking",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "subId1",
                label: "Sub ID 1",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "subId2",
                label: "Sub ID 2",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "subId3",
                label: "Sub ID 3",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "subId4",
                label: "Sub ID 4",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "subId5",
                label: "Sub ID 5",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "campaign",
                label: "Campaign",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "coupon",
                label: "Coupon",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "postedDate",
                label: "Posted Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>
                        );
                    }
                }
            },
            {
                name: "clickId",
                label: "Click ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "clickDate",
                label: "Click Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>
                        );
                    }
                }
            },
            {
                name: "eventDate",
                label: "Event Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>
                        );
                    }
                }
            },
            {
                name: "lockingDate",
                label: "Locking Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>
                        );
                    }
                }
            },
            {
                name: "orderNumber",
                label: "Order Number",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "orderStatus",
                label: "Order Status",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "currency",
                label: "Currency",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "saleAmount",
                label: "Sale Amount",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>
                        );
                    }
                }
            },
            {
                name: "commission",
                label: "Commission",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>
                        );
                    }
                }
            },
            {
                name: "ipAddress",
                label: "IP Address",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "isPaid",
                label: "Is Paid",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "dtPaid",
                label: "Date Paid",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>
                        );
                    }
                }
            },
            {
                name: "totalCount",
                label: "Total Count",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "legacyId",
                label: "Legacy ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "modifiedDateRaw",
                label: "Modified Date Raw",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "adjustmentReason",
                label: "Adjustment Reason",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "adjustmentType",
                label: "Adjustment Type",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "httpReferer",
                label: "HTTP Referer",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "country",
                label: "Country",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "region",
                label: "Region",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "city",
                label: "City",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "device",
                label: "Device",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "browser",
                label: "Browser",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "platform",
                label: "Platform",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "items",
                label: "Items",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "createdBy",
                label: "Created By",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "createdDate",
                label: "Created Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>
                        );
                    }
                }
            },
            {
                name: "modifiedBy",
                label: "Modified By",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "modifiedDate",
                label: "Modified Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return (
                            <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>
                        );
                    }
                }
            }
        ];



        return (
            <div>
                <ThemeProvider theme={this.state.CommissionsTable.getTheme()}>
                    <MUIDataTable
                        title={
                            <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px" }}>{this.props.affiliateProgramManager?.name + " commissions by ID" ?? "No affiliate selected"}</p>
                                <p style={{ fontSize: '16px', marginTop: "10px", color: "red", display: this.state.affiliateCommissionIdError ? "" : "none" }}>Enter an affiliate commission ID</p>
                            </div>
                        }
                        data={this.state.commissions}
                        columns={columns}
                        options={{
                            ...this.state.CommissionsTable.options,
                            textLabels: {
                                body: { noMatch: this.state.commissionsLoading ? "LOADING..." : "No data available" },
                            },
                            selectableRows: "none",
                        }}
                        ref={this.tableRef}
                    />FlexoffersCommissionData
                </ThemeProvider>
            </div>
        );
    }
}

export default FlexoffersCommissionData;
